const catSlider = {
	el: document.querySelector(".atk-parent-category-carousel"),
	load: function (el, row, diff) {
		if (window.gsap) {
			window.utils.loadScript(
				window.baseUrl + "/js/external/gsap-scrolltrigger.min.js",
				false,
				function () {
					gsap.registerPlugin(window.ScrollTrigger);
					catSlider.translate(el, row, diff);
				},
				true
			);
		} else {
			setTimeout(function () {
				catSlider.load(el, row, diff);
			}, 100);
		}
	},
	set: function (el) {
		const row = el.querySelector(".wrapper");
		const sticky = el.querySelector(".sticky-container");
		const catsLength = el.querySelectorAll(".single-term").length;
		const diff = row.scrollWidth - el.offsetWidth + 60;
		const newHeight = 60 * catsLength + "vh";
		el.style.height = newHeight;
		sticky.style.top = (window.innerHeight - sticky.offsetHeight) / 2 + "px";
		catSlider.load(el, row, diff);
		catSlider.observer.observe(el);
	},
	observer: new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting || entry.intersectionRatio > 0) {
				if (!entry.target.hasAttribute("running")) {
					entry.target.setAttribute("running", "");
				}
			} else {
				if (entry.target.hasAttribute("running")) {
					entry.target.removeAttribute("running");
				}
			}
		});
	}),
	translate: function (el, row, diff) {
		gsap
			.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top-=" + window.utils.screen.height / 2 + " top",
					end: "bottom+=80 bottom",
					scrub: 1.2,
				},
			})
			.to(row, { x: -diff, duration: 1, ease: "none" });
	},
	init: function () {
		if (
			catSlider.el &&
			window.utils.screen.width >= window.utils.breakpoint.lg
		) {
			catSlider.set(catSlider.el);
		}
	},
};

catSlider.init();
